import { render, staticRenderFns } from "./SystemTagInput.vue?vue&type=template&id=4120a2d7&scoped=true&"
import script from "./SystemTagInput.vue?vue&type=script&lang=js&"
export * from "./SystemTagInput.vue?vue&type=script&lang=js&"
import style0 from "./SystemTagInput.vue?vue&type=style&index=0&id=4120a2d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120a2d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4120a2d7')) {
      api.createRecord('4120a2d7', component.options)
    } else {
      api.reload('4120a2d7', component.options)
    }
    module.hot.accept("./SystemTagInput.vue?vue&type=template&id=4120a2d7&scoped=true&", function () {
      api.rerender('4120a2d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/SystemTagInput.vue"
export default component.exports